module.exports = __webpack_public_path__ + "static/media/under_maintainace.ab56dc57.png";